import React, { useEffect, useRef, useState } from 'react';
import { FaCheckCircle, FaShieldAlt, FaUserMd, FaDollarSign, FaHome, FaLock, FaHeart, FaLightbulb } from 'react-icons/fa';
import styles from './WhyChooseUs.module.css';

const WhyChooseUs = () => {
  const [visibleItems, setVisibleItems] = useState([]);
  const sectionRef = useRef(null);

  const features = [
    {
      id: 1,
      title: 'Premium & Hygienic Environment',
      description: 'Spotless, sanitized rooms with premium amenities',
      icon: FaShieldAlt
    },
    {
      id: 2,
      title: 'Experienced Female Therapists',
      description: 'Certified professionals with years of expertise',
      icon: FaUserMd
    },
    {
      id: 3,
      title: 'Affordable Rates',
      description: 'Luxury massage services at competitive prices',
      icon: FaDollarSign
    },
    {
      id: 4,
      title: 'Cozy Rooms & Soothing Lights',
      description: 'Relaxing ambiance designed for ultimate comfort',
      icon: FaLightbulb
    },
    {
      id: 5,
      title: '100% Privacy Guarantee',
      description: 'Complete confidentiality and secure environment',
      icon: FaLock
    },
    {
      id: 6,
      title: 'Doorstep Service Available',
      description: 'Professional massage service at your home',
      icon: FaHome
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const itemIndex = parseInt(entry.target.dataset.index);
            setVisibleItems(prev => [...new Set([...prev, itemIndex])]);
          }
        });
      },
      { threshold: 0.3 }
    );

    const items = sectionRef.current?.querySelectorAll('[data-feature-item]');
    items?.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  return (
    <section className={styles.whyChooseUs} ref={sectionRef}>
      <div className={styles.container}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.title}>Why Choose Sanaya Spa?</h2>
          <p className={styles.subtitle}>Experience the difference with our premium massage services</p>
        </div>

        <div className={styles.featuresGrid}>
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            const isVisible = visibleItems.includes(index);
            
            return (
              <div
                key={feature.id}
                className={`${styles.featureItem} ${isVisible ? styles.visible : ''}`}
                data-index={index}
                data-feature-item
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                <div className={styles.featureContent}>
                  <div className={styles.iconContainer}>
                    <FaCheckCircle className={styles.checkIcon} />
                    <IconComponent className={styles.featureIcon} />
                  </div>
                  
                  <div className={styles.textContent}>
                    <h3 className={styles.featureTitle}>{feature.title}</h3>
                    <p className={styles.featureDescription}>{feature.description}</p>
                  </div>
                </div>
                
                <div className={styles.itemGlow}></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;